import background from './Images/traffic.jpg';
import allCards from './Images/acceptancemarks_US_standard.jpg';
import stripe from './Images/powered_by_stripe.png';

// eslint-disable-next-line
const backgroundConst = {
  background,allCards,stripe
};
// eslint-disable-next-line
export default backgroundConst;
